import {useDispatch, useSelector} from "react-redux";
import Button, {BtnColor} from "../../../components/Button/Button";
import PulseLoader from "react-spinners/PulseLoader";
import {useTranslation} from "react-i18next";
import {
    onDiscountsLoad,
    onIikoTransportImportDiscounts,
} from "../../../store/Restaurant/actions";
import Pagination from "../../../components/Pagination/Pagination";
import Loading from "../../../components/Loading";
import {useQuery} from "../../../utils/useQuery";
import {useEffect} from "react";
import DiscountsList from "./DiscountsList";
import { useParams } from 'react-router-dom';

const ImportIikoTransportDiscounts = ({ integration, importDiscounts }) => {
    const { t } = useTranslation()
    if (!integration?.selected?.organization_id) {
        return null
    }

    let loading = integration.tables.loading

    return (
        <div className="px-3 py-3 relative">
            <Button color={BtnColor.gold}
                    disabled={!integration?.selected?.organization_id}
                    className={"absolute bottom-0"}
                    type={"button"}
                    onClick={importDiscounts}>
                {loading ? (
                    <PulseLoader color="rgba(255, 255, 255, 1)" loading={loading}  size={5} />
                ) : t('Import discounts') }
            </Button>
        </div>
    )
}
const Discounts = () => {
    const { slug: restId } = useParams();

    const query = useQuery();
    const dispatch = useDispatch()
    const iikoTransportIntegration = useSelector(state => state.restaurant.iiko_transport)
    const { integrationId, loading } = useSelector(state => ({
        integrationId: state.restaurant.pos_selected?.integration_id,
        loading: state.restaurant.iiko_transport.discounts.loading
    }))

    const importDiscounts = () => dispatch(onIikoTransportImportDiscounts(restId, integrationId))

    const { items, current_page, per_page, total, links } = useSelector(state => ({
        items : state.restaurant.iiko_transport.common?.discounts?.data,
        current_page: state.restaurant.iiko_transport.common?.discounts.current_page,
        per_page: state.restaurant.iiko_transport.common?.discounts.per_page,
        total: state.restaurant.iiko_transport.common?.discounts.total,
        links: state.restaurant.iiko_transport.common?.discounts.links,
    }))

    const page = query.get('page')
    const pagination = {
        page: current_page,
        limit: per_page,
        total,
        links,
    }
    useEffect(() => {
        dispatch(onDiscountsLoad(restId, page))
    }, [restId, page])

    return (
        <div className="mt-5">
            <ImportIikoTransportDiscounts integration={iikoTransportIntegration} importDiscounts={importDiscounts} />

            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <Loading loading={loading}>
                    <DiscountsList integration={iikoTransportIntegration} items={items} />
                    <Pagination pagination={pagination} />
                </Loading>
            </div>
        </div>
    )
}

export default Discounts;
